// / <reference path="modules/cpp-returns/cpp-returns-dashboard/cpp-returns-dashboard.component.ts" />
// / <reference path="modules/cpp-returns/cpp-returns-dashboard/cpp-returns-dashboard.component.ts" />
// Angular Lib
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Project Lib/Class
import { LandingDataComponent } from './modules/seed/order/dashboard/landing-data.component';
import { OrderViewComponent } from './modules/seed/order/order-view/order-view.component';
import { GrowerOrderDetailComponent } from './modules/seed/order/grower/grower-order-details/grower-order-details.component';
import { DealerOrderViewComponent } from './modules/seed/order/dealer-order-view/dealer-order-view.component';
import { GrowerOrderAddComponent } from './modules/seed/order/grower/grower-order-add/grower-order-add.component';
import { UserSecurityComponent } from './modules/common/user-security/user-security.component';
import { EmulationDashboardComponent } from './modules/seed/emulation/emulation-dashboard/emulation-dashboard.component';
import { LandingSeedFulfillmentComponent } from './modules/seed/fullfillment/landing-seed-fulfillment/landing-seed-fulfillment.component';
import { CreateEditSeedFulfillmentComponent } from './modules/seed/fullfillment/create-edit-seed-fulfillment/create-edit-seed-fulfillment.component';
import { AuthGuard } from './auth.guard';
import { GrowerSearchComponent } from './common/components/grower-search/grower-search.component';
import { LogoutComponent } from './modules/common/logout/logout.component';
import { ReportDashboardComponent } from './modules/seed/report/report-dashboard/report-dashboard.component';
import { QuickOrderSearchComponent } from './modules/seed/report/quick-order-search/quick-order-search.component';
import { ItemAvailabilityComponent } from './modules/seed/report/item-availability/item-availability.component';
import { DealerOrderAuditComponent } from './modules/seed/report/dealer-order-audit/dealer-order-audit.component';
import { GrowerOrderAuditComponent } from './modules/seed/report/grower-order-audit/grower-order-audit.component';
import { AppResolver } from './services/infrastructure/app-resolver.service';
import { UnAuthorizeComponent } from './modules/common/unauth/unauthorize.component';
import { TotalOrderSummaryComponent } from './modules/seed/report/total-order-summary/total-order-summary.component';
import { PrepayLandingComponent } from './modules/common/prepay/prepay-landing/prepay-landing.component';
import { NewPrePayRequestComponent } from './modules/common/prepay/new-prepay-request/new-prepay-request.component';
import { PrepayContractComponent } from './modules/common/prepay/prepay-contract/prepay-contract.component';
import { EditPrePayRequestComponent } from './modules/common/prepay/edit-prepay-request/edit-prepay-request.component';
import { ShippableProductsReportComponent } from './modules/seed/report/shippable-products-report/shippable-products-report.component';
import { ReleaseItemsAuditComponent } from './modules/seed/fullfillment/release-items-audit/release-items-audit.component';
import { CppLandingComponent } from './modules/cpp/cpp-landing/cpp-landing.component';
import { CppCreateOrderComponent } from './modules/cpp/cpp-create-order/cpp-create-order.component';
import { CppOrderSummaryComponent } from './modules/cpp/cpp-order-summary/cpp-order-summary.component';
import { CppErrorOrderMaintenanceComponent } from './modules/cpp/cpp-error-order-maintenance/cpp-error-order-maintenance.component';
import { CppErrorOrderMaintenanceDashboardComponent } from './modules/cpp/cpp-error-order-maintenance-dashboard/cpp-error-order-maintenance-dashboard.component';
import { LicensingDashboardComponent } from './modules/seed/licensing/licensing-dashboard/licensing-dashboard.component';
import { CppPriceListDashboardComponent } from './modules/cpp/cpp-price-list-dashboard/cpp-price-list-dashboard.component';
import { CppCustomerPriceListComponent } from './modules/cpp/cpp-customer-price-list/cpp-customer-price-list.component';
import { CppPricelistManageSubscriptionComponent } from './modules/cpp/cpp-pricelist-manage-subscription/cpp-pricelist-manage-subscription.component';
import { SubstitutionOrderReportComponent } from './modules/seed/report/substitution-order-report/substitution-order-report.component';
import { SeedReturnsSoybeanDashboardComponent } from './modules/seed/seed-returns-soybean/seed-returns-soybean-dashboard/seed-returns-soybean-dashboard.component';
import { SeedReturnsSoybeanCreateEditComponent } from './modules/seed/seed-returns-soybean/create-edit-request/seed-returns-soybean-create-edit.component';
import { OtiOrderSummaryComponent } from './modules/oti/oti-order-summary/oti-order-summary.component';
import { ViewQuoteDetailsComponent } from './modules/quote-order/view-quote-details/view-quote-details.component';
import { CreateQuoteOrderComponent } from './modules/quote-order/create-quote-order/create-quote-order.component';
import { ViewQuoteOrderComponent } from './modules/quote-order/view-quote-order/view-quote-order.component';
import { QuoteOrderSummaryComponent } from './modules/quote-order/quote-order-summary/quote-order-summary.component';
import { SeedReturnsDashboardComponent } from './modules/seed/seed-returns/seed-returns-dashboard/seed-returns-dashboard.component';
import { SeedReturnsCreateEditComponent } from './modules/seed/seed-returns/seed-returns-create-edit/seed-returns-create-edit.component';
import { SeedReturnsReviewComponent } from './modules/seed/seed-returns/seed-returns-review/seed-returns-review.component';
import { SeedReturnsConfirmationComponent } from './modules/seed/seed-returns/seed-returns-confirmation/seed-returns-confirmation.component';
import { CreateBlanketOrderComponent } from './modules/blanket-order/create-blanket-order/create-blanket-order.component';
import { BlanketOrderSummaryComponent } from './modules/blanket-order/blanket-order-summary/blanket-order-summary.component';
import { SeedReturnsApproveRejectComponent } from './modules/seed/seed-returns/seed-returns-approve-reject/seed-returns-approve-reject.component';

import { CppReturnsDashboardComponent } from './modules/cpp-returns/cpp-returns-dashboard/cpp-returns-dashboard.component';
import { CppReturnsCreateEditComponent } from './modules/cpp-returns/cpp-returns-create-edit/cpp-returns-create-edit.component';
import { CppReturnsReviewComponent } from './modules/cpp-returns/cpp-returns-review/cpp-returns-review.component';
import { CppReturnsConfirmationComponent } from './modules/cpp-returns/cpp-returns-confirmation/cpp-returns-confirmation.component';

import { ContainerReturnsDashboardComponent } from './modules/container-returns/container-returns-dashboard/container-returns-dashboard.component';
import { ContainerReturnsAddEditComponent } from './modules/container-returns/container-returns-add-edit/container-returns-add-edit.component';
import { ContainerReturnsReviewComponent } from './modules/container-returns/container-returns-review/container-returns-review.component';
import { CppReturnsApproveRejectComponent } from './modules/cpp-returns/cpp-returns-approve-reject/cpp-returns-approve-reject.component';

import { CppCoiLandingComponent } from './modules/cpp-coi/cpp-coi-landing/cpp-coi-landing.component';
import { CppCoiRequestEntryComponent } from './modules/cpp-coi/cpp-coi-request-entry/cpp-coi-request-entry.component';
import { CppCoiRequestConfirmationComponent } from './modules/cpp-coi/cpp-coi-request-confirmation/cpp-coi-request-confirmation.component';
import { SeedReplantLandingComponent } from './modules/seed/seed-replant/seed-replant-landing/seed-replant-landing.component';
import { SeedReplantRequestEntryComponent } from './modules/seed/seed-replant/seed-replant-request-entry/seed-replant-request-entry.component';
import { SeedReplantReviewComponent } from './modules/seed/seed-replant/seed-replant-review/seed-replant-review.component';
import { SeedCropLossLandingComponent } from './modules/seed/seed-crop-loss/seed-crop-loss-landing/seed-crop-loss-landing.component';
import { SeedCropLossRequestEntryComponent } from './modules/seed/seed-crop-loss/seed-crop-loss-request-entry/seed-crop-loss-request-entry.component';
import { SeedCropLossReviewComponent } from './modules/seed/seed-crop-loss/seed-crop-loss-review/seed-crop-loss-review.component';
import { StockTransferLandingComponent } from './modules/seed/sot/sot-landing/sot-landing.component';
import { StockTransferRequestEntryComponent } from './modules/seed/sot/sot-request-entry/sot-request-entry.component';
import { StockTransferApproveRejectComponent } from './modules/seed/sot/sot-approve-reject/sot-approve-reject.component';
import { ContainerReturnsConfirmationComponent } from './modules/container-returns/container-returns-confirmation/container-returns-confirmation.component';
import { ShippingAvailabilityComponent } from './modules/seed/report/shipping-availability/shipping-availability.component';

import { LandingDeliveryInstructionsComponent } from './modules/seed/fullfillment/delivery-instructions/delivery-instructions-landing/delivery-instructions-landing.component';
import { CreateEditDeliveryInstructionsComponent } from './modules/seed/fullfillment/delivery-instructions/delivery-instructions-create-edit/create-edit-delivery-Instructions.component';
import { CppSraCostSheetRetailComponent } from './modules/cpp-sra-cost-sheet/cpp-sra-cost-sheet-retail/cpp-sra-cost-sheet-retail.component';
import { CppSraCostSheetPriceSimulationComponent } from './modules/cpp-sra-cost-sheet/cpp-sra-cost-sheet-price-simulation/cpp-sra-cost-sheet-price-simulation.component';

import { CppSulfurZincPricingComponent } from './modules/cpp/reports/cpp-sulfur-zinc-pricing/cpp-sulfur-zinc-pricing.component';
import { CppAMSPricingComponent } from './modules/cpp/reports/cpp-ams-pricing/cpp-ams-pricing.component';
import { CppAmsPricingManageSubscriptionComponent } from './modules/cpp/reports/cpp-ams-pricing-manage-subscription/cpp-ams-pricing-manage-subscription.component';
import { CppSulfurZincPricingManageSubscriptionComponent } from './modules/cpp/reports/cpp-sulfur-zinc-pricing-manage-subscription/cpp-sulfur-zinc-pricing-manage-subscription.component';
import { EverydayLowPriceListComponent } from './modules/cpp/reports/everyday-low-price-list/everyday-low-price-list.component';
import { SubscriptionLandingPageComponent } from './modules/subscription-management/subscription-landing-page/subscription-landing-page.component';

import { CppLandingDeliveryInstructionsComponent } from './modules/cpp/cpp-delivery-instructions/cpp-delivery-instructions-landing/cpp-delivery-instructions-landing.component';
import { CppCreateEditDeliveryInstructionsComponent } from './modules/cpp/cpp-delivery-instructions/cpp-delivery-instructions-create-edit/cpp-create-edit-delivery-Instructions.component';
import { CppUserListLandingComponent } from './modules/cpp/cpp-user-list/cpp-user-list-landing/cpp-user-list-landing.component';
import { CppUserListCreateEditComponent } from './modules/cpp/cpp-user-list/cpp-user-list-create-edit/cpp-create-edit-user-list.component';
import { SeedReturnsSoybeanZeroDumpsComponent } from './modules/seed/seed-returns-soybean/seed-returns-soybean-zero-dumps/seed-returns-soybean-zero-dumps.component';
import { GrowerProgramDashboardComponent } from './modules/grower-program/grower-program-dashboard/grower-program-dashboard.component';
import { OtiOrderLandingComponent } from './modules/oti/oti-order-landing/oti-order-landing.component';
import { ProductLabelLandingComponent } from './modules/cpp/cpp-product-label-orders/product-label-landing/product-label-landing.component';
import { SeedDiscretionaryDashboardComponent } from './modules/grower-program/seed-discretionary-dashboard/seed-discretionary-dashboard.component';
import { CppProductLabelFormComponent } from './modules/cpp/cpp-product-label-orders/cpp-product-label-form/cpp-product-label-form.component';
import { CommandCenterComponent } from './modules/command-center/cc-landing/cc-landing.component';
import { CppMarketingProgramDashboardComponent } from './modules/cpp-marketing-program/marketing-program-landing/cpp-marketing-program-dashboard.component';
import { SraOrdersLandingComponent } from './modules/cpp/sra-orders/sra-orders-landing/sra-orders-landing.component';
import { SraCreateOrderComponent } from './modules/cpp/sra-orders/sra-create-order/sra-create-order.component';
import { SraOrdersAprroveReviewComponent } from './modules/cpp/sra-orders/sra-orders-approve-review/sra-orders-approve-review.component';
import { SraErrorOrderMaintenanceComponent } from './modules/cpp/sra-orders/sra-error-order-maintenance/sra-error-order-maintenance.component';
import { SraErrorOrderMaintenanceDashboardComponent } from './modules/cpp/sra-orders/sra-error-order-maintenance-dashboard/sra-error-order-maintenance-dashboard.component';
import { SeedReservationLandingComponent } from './modules/seed/seed-reservation/seed-reservation-landing/seed-reservation-landing.component';
import { SeedReservationCreateComponent } from './modules/seed/seed-reservation/seed-reservation-create/seed-reservation-create.component';
import { SeedReservationConfirmationComponent } from './modules/seed/seed-reservation/seed-reservation-confirmation/seed-reservation-confirmation.component';
import { AssociateCropLandingComponent } from './modules/seed/associate-crop/associate-crop-landing/associate-crop-landing.component';
import { AssociateCropCreateOrderComponent } from './modules/seed/associate-crop/associate-crop-create-order/associate-crop-create-order.component';
import { AssociateCropSummaryComponent } from './modules/seed/associate-crop/associate-crop-summary/associate-crop-summary.component';
import { PlotSeedLandingComponent } from './modules/seed/plot-seed/plot-seed-landing/plot-seed-landing.component';
import { PlotSeedCreateOrderComponent } from './modules/seed/plot-seed/plot-seed-create-order/plot-seed-create-order.component';
import { PlotSeedSummaryComponent } from './modules/seed/plot-seed/plot-seed-summary/plot-seed-summary.component';
import { CppPriceListLookupGridComponent } from './modules/cpp/cpp-price-list-lookup-grid/cpp-price-list-lookup-grid.component';
import { AssociateCropReconciliationLandingComponent } from './modules/seed/associate-crop/associate-crop-reconciliation-landing/associate-crop-reconciliation-landing.component';
import { AssociateCropInventoryComponent } from './modules/seed/associate-crop/associate-crop-inventory/associate-crop-inventory.component';
import { PlotSeedReleaseLandingComponent } from './modules/seed/plot-seed/plot-seed-release-landing/plot-seed-release-landing.component';
import { PlotSeedReleaseOrderComponent } from './modules/seed/plot-seed/plot-seed-release-order/plot-seed-release-order.component';
import { PlotSeedReleaseReviewComponent } from './modules/seed/plot-seed/plot-seed-release-review/plot-seed-release-review.component';
import { SeedReservationReconcileCreateComponent } from './modules/seed/seed-reservation/seed-reservation-reconcile-create/seed-reservation-reconcile-create.component';
import { SeedReservationReconcileGrowerOrderComponent } from './modules/seed/seed-reservation/seed-reservation-reconcile-grower-order/seed-reservation-reconcile-grower-order.component';
const routes: Routes = [

  {
    path: 'landing-data',
    component: LandingDataComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'seed-fulfillment',
    component: LandingSeedFulfillmentComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'seed-fulfillment/:accountNo/:releaseId',
    component: CreateEditSeedFulfillmentComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'reports/shipping-availability/release-order',
    component: CreateEditSeedFulfillmentComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'release-items-audit',
    component: ReleaseItemsAuditComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'delivery-instructions',
    component: LandingDeliveryInstructionsComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'delivery-instructions-create-edit',
    component: CreateEditDeliveryInstructionsComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'orders', component: OrderViewComponent,
    children: [
      {
        path: 'grower-order-detail/:accountNo/:growerOrderId',
        component: GrowerOrderDetailComponent,
        runGuardsAndResolvers: 'always',
        canActivate: [AuthGuard],
        resolve: {
          evoleAccess: AppResolver
        }
      },
      {
        path: 'grower-order-add/:accountNo',
        component: GrowerOrderAddComponent,
        runGuardsAndResolvers: 'always',
        canActivate: [AuthGuard],
        resolve: {
          evoleAccess: AppResolver
        }
      },
      {
        path: 'dealer-order-view/:accountNo/:dealerOrderId/:selectedDealerAccountNo',
        component: DealerOrderViewComponent,
        runGuardsAndResolvers: 'always',
        canActivate: [AuthGuard],
        resolve: {
          evoleAccess: AppResolver
        }
      }
    ]
  },
  {
    path: 'cc/landing-data',
    component: CommandCenterComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'order/dashboard',
    component: OtiOrderLandingComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'oti/oti-order-summary/:salesOrderNumber/:orderType',
    component: OtiOrderSummaryComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'cpp/landing-data',
    component: CppLandingComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'cpp/error-order-maintenance-dashboard',
    component: CppErrorOrderMaintenanceDashboardComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'cpp/error-order-maintenance',
    component: CppErrorOrderMaintenanceComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'sro/error/order-maintenance-dashboard',
    component: SraErrorOrderMaintenanceDashboardComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'sro/error/order-maintenance',
    component: SraErrorOrderMaintenanceComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },


  {
    path: 'cpp/cpp-order-create',
    component: CppCreateOrderComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'cpp/cpp-order-summary',
    component: CppOrderSummaryComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'sra/sra-order-summary',
    component: CppOrderSummaryComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'cpp/blanket-order-create',
    component: CreateBlanketOrderComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'cpp/blanket-order-summary',
    component: BlanketOrderSummaryComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'cpp/price-list-dashboard',
    component: CppPriceListDashboardComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'cpp/price-list-dashboard/:accountNo',
    component: CppPriceListDashboardComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'cpp/customer-price-list',
    component: CppCustomerPriceListComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'pricelistLookup/customer-price-list',
    component: CppCustomerPriceListComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'pricelistLookup/cpp-price-list-lookup-grid',
    component: CppPriceListLookupGridComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'pricelistLookup/cpp-price-list-lookup-grid/:accountNo',
    component: CppPriceListLookupGridComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'cpp/price-list-manage-subscription/:accountNo',
    component: CppPricelistManageSubscriptionComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'cpp/sra-cost-sheet-retail',
    component: CppSraCostSheetRetailComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'cpp/sra-cost-sheet-price-simulation',
    component: CppSraCostSheetPriceSimulationComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'cpp/report/sulfur-zinc-pricing',
    component: CppSulfurZincPricingComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'cpp/report/ams-pricing',
    component: CppAMSPricingComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'cpp/report/prop-hif-price-sheet',
    component: EverydayLowPriceListComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'cpp/report/ams-pricing-manage-subscription',
    component: CppAmsPricingManageSubscriptionComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'cpp/report/sulfur-zinc-pricing-manage-subscription',
    component: CppSulfurZincPricingManageSubscriptionComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'cpp-returns/dashboard-products',
    component: CppReturnsDashboardComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'cpp-returns/dashboard-products/:productLine',
    component: CppReturnsDashboardComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'cpp-returns/request-products/:returnRequestCppId',
    component: CppReturnsCreateEditComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'cpp-returns/request-products',
    component: CppReturnsCreateEditComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'cpp-returns/products-review/:returnRequestId',
    component: CppReturnsReviewComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'cpp-returns/products-confirmation/:returnRequestId',
    component: CppReturnsConfirmationComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'cpp-returns/products-approve-reject/:returnRequestId',
    component: CppReturnsApproveRejectComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'cpp/cpp-delivery-instructions',
    component: CppLandingDeliveryInstructionsComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'cpp/cpp-user-list',
    component: CppUserListLandingComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'cpp/cpp-create-edit-user-list',
    component: CppUserListCreateEditComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'cpp/product-label-landing',
    component: ProductLabelLandingComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'cpp/orders/sra-order-landing',
    component: SraOrdersLandingComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'cpp/orders/sra-create-order',
    component: SraCreateOrderComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'cpp/orders/sra-orders-approve-review',
    component: SraOrdersAprroveReviewComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'cpp/cpp-create-edit-delivery-instructions',
    component: CppCreateEditDeliveryInstructionsComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'cpp/cpp-product-label-form',
    component: CppProductLabelFormComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'container-returns/dashboard-products',
    component: ContainerReturnsDashboardComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'container-returns/products-confirmation/:returnRequestId',
    component: ContainerReturnsConfirmationComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'container-returns/request-products/:containerReturnRequestId',
    component: ContainerReturnsAddEditComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'container-returns/request-products',
    component: ContainerReturnsAddEditComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'container-returns/products-review',
    component: ContainerReturnsReviewComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },

  {
    path: 'cpp/cpp-coi-landing',
    component: CppCoiLandingComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'cpp/cpp-coi-request-entry',
    component: CppCoiRequestEntryComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'cpp/cpp-coi-request-entry/:coiorderNumber',
    component: CppCoiRequestEntryComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'cpp/cpp-coi-request-confirmation',
    component: CppCoiRequestConfirmationComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'cpp/marketing-program-landing',
    component: CppMarketingProgramDashboardComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'seed-returns-soybean-dashboard',
    component: SeedReturnsSoybeanDashboardComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'sot-landing',
    component: StockTransferLandingComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'seed-returns-soybean/return-request/:returnRequestId',
    component: SeedReturnsSoybeanCreateEditComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'seed-returns-soybean/return-request',
    component: SeedReturnsSoybeanCreateEditComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'seed-returns-soybean/zerodump-toreport',
    component: SeedReturnsSoybeanZeroDumpsComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'seed-replant-landing',
    component: SeedReplantLandingComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'seed-replant-request-entry',
    component: SeedReplantRequestEntryComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'grower-program/budgeted-spend',
    component: GrowerProgramDashboardComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'grower-program/seed-discretionary',
    component: SeedDiscretionaryDashboardComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'sot-request-entry',
    component: StockTransferRequestEntryComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'sot-request-review/:sotRequestId/:isSubmit',
    component: StockTransferApproveRejectComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'seed-replant-request-entry/:requestId/:isApprover',
    component: SeedReplantRequestEntryComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'seed-replant-review',
    component: SeedReplantReviewComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'seed-replant-approve',
    component: SeedReplantReviewComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'seed-replant-view-request',
    component: SeedReplantReviewComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'crop-loss-landing',
    component: SeedCropLossLandingComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'crop-loss-request-entry',
    component: SeedCropLossRequestEntryComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'crop-loss-request-entry/:requestId/:isApprover',
    component: SeedCropLossRequestEntryComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'crop-loss-review',
    component: SeedCropLossReviewComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'crop-loss-approve',
    component: SeedCropLossReviewComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'crop-loss-view-request',
    component: SeedCropLossReviewComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'account',
    component: UserSecurityComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'emulation',
    component: EmulationDashboardComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'licenses/grower/:growerName',
    component: LicensingDashboardComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'licenses/:licenseStatus/:growerOrderNumber',
    component: LicensingDashboardComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'licenses/:licenseStatus',
    component: LicensingDashboardComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'licenses',
    component: LicensingDashboardComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'prepay',
    component: PrepayLandingComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'new-prepay-request',
    component: NewPrePayRequestComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'edit-prepay-request',
    component: EditPrePayRequestComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'prepay-contract',
    component: PrepayContractComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'reports',
    component: ReportDashboardComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    children: [
      {
        path: 'order-detail-report',
        component: QuickOrderSearchComponent,
        runGuardsAndResolvers: 'always',
        resolve: {
          evoleAccess: AppResolver
        }
      },
      {
        path: 'product-availability-report',
        component: ItemAvailabilityComponent,
        runGuardsAndResolvers: 'always',
        resolve: {
          evoleAccess: AppResolver
        }
      },
      {
        path: 'dealer-order-audit',
        component: DealerOrderAuditComponent,
        runGuardsAndResolvers: 'always',
        resolve: {
          evoleAccess: AppResolver
        }
      },
      {
        path: 'grower-order-audit',
        component: GrowerOrderAuditComponent,
        runGuardsAndResolvers: 'always',
        resolve: {
          evoleAccess: AppResolver
        }
      },
      {
        path: 'total-order-summary',
        component: TotalOrderSummaryComponent,
        runGuardsAndResolvers: 'always',
        resolve: {
          evoleAccess: AppResolver
        }
      },
      {
        path: 'shippable-products-report',
        component: ShippableProductsReportComponent,
        runGuardsAndResolvers: 'always',
        resolve: {
          evoleAccess: AppResolver
        }
      },
      {
        path: 'substitution-order-report',
        component: SubstitutionOrderReportComponent,
        runGuardsAndResolvers: 'always',
        resolve: {
          evoleAccess: AppResolver
        }
      },
      {
        path: 'shipping-availability-report',
        component: ShippingAvailabilityComponent,
        runGuardsAndResolvers: 'always',
        resolve: {
          evoleAccess: AppResolver
        }
      }
    ]
  },
  {
    path: 'quote/view-quote-details/:quoteNumber',
    component: ViewQuoteDetailsComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'quote/create-quote-order',
    component: CreateQuoteOrderComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'quote/quote-order-summary',
    component: QuoteOrderSummaryComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'quote/view-quote-order',
    component: ViewQuoteOrderComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'grower',
    component: GrowerSearchComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'seed-returns-dashboard/:productLine',
    component: SeedReturnsDashboardComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },

  {
    path: 'seed-returns/return-request/:returnRequestId',
    component: SeedReturnsCreateEditComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'seed-returns/return-request',
    component: SeedReturnsCreateEditComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'seed-returns/return-review/:returnRequestId',
    component: SeedReturnsReviewComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'seed-returns/return-approve-reject/:returnRequestId',
    component: SeedReturnsApproveRejectComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'seed-returns/return-confirmation/:returnRequestNumber',
    component: SeedReturnsConfirmationComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'seed-reservation-landing',
    component: SeedReservationLandingComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'seed-reservation/seed-reservation-create',
    component: SeedReservationCreateComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'seed-reservation/seed-reservation-confirmation',
    component: SeedReservationConfirmationComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'seed-reservation/seed-reservation-reconcile-create',
    component: SeedReservationReconcileCreateComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'seed-reservation/seed-reservation-reconcile-grower-order',
    component: SeedReservationReconcileGrowerOrderComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'container-returns/products-review/:containerReturnRequestId',
    component: ContainerReturnsReviewComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'subscription-landing-page',
    component: SubscriptionLandingPageComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'associate-crop-landing',
    component: AssociateCropLandingComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'associate-crop/associate-crop-create-order',
    component: AssociateCropCreateOrderComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'associate-crop/associate-crop-summary',
    component: AssociateCropSummaryComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'associate-crop-reconciliation-landing',
    component: AssociateCropReconciliationLandingComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'associate-crop-inventory',
    component: AssociateCropInventoryComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'plot-seed-landing',
    component: PlotSeedLandingComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'plot-seed/plot-seed-create-order',
    component: PlotSeedCreateOrderComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'plot-seed/plot-seed-summary',
    component: PlotSeedSummaryComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'plot-seed/plot-seed-release-landing',
    component: PlotSeedReleaseLandingComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'plot-seed/plot-seed-release-order',
    component: PlotSeedReleaseOrderComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'plot-seed/plot-seed-release-review',
    component: PlotSeedReleaseReviewComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    resolve: {
      evoleAccess: AppResolver
    }
  },
  {
    path: 'logout',
    component: LogoutComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard]
  },
  {
    path: 'unauthorize',
    component: UnAuthorizeComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard]
  },
  {
    path: '',
    redirectTo: 'cc/landing-data',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: 'cc/landing-data'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
  providers: [AppResolver] // Add NewsResolver to the providers array
})

export class AppRoutingModule { }
